module.exports = __webpack_public_path__ + "static/media/icon-pending.dee438fa.svg";